'use client';

var TRIGGER_HASH = '#formCallMeBack';

export { TRIGGER_HASH };
//# sourceMappingURL=const.js.map
